// extracted by mini-css-extract-plugin
export default {"button":"styles_button__A8OWK","disabled":"styles_disabled__ZDYdS"};